import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import * as dayjs from 'dayjs';
import 'dayjs/locale/hr';
import * as localeData from 'dayjs/plugin/localeData';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private languageChanged: BehaviorSubject<string> = new BehaviorSubject<string>('hr');
  languageChanged$: Observable<string> = this.languageChanged.asObservable();
  constructor(
    private translocoService: TranslocoService,
  ) {
  }

  initLanguages() {
    dayjs.extend(localeData);
    dayjs.extend(customParseFormat);
    dayjs().localeData();
    this.translocoService.langChanges$.subscribe((language) => {
      dayjs.locale(language);
      this.languageChanged.next(language);
    });
  }
}
